const translation = {
    PageSize: 'Розмір сторінки',
    PageOrientation: 'Орієнтація сторінки',
    Format: 'Формат',
    DPI: 'DPI',
    Title: 'Експорт карти',
    Close: 'Закрити',
    Save: 'Зберегти',
    FileName: "Ім'я файлу",
    Landscape: 'Альбомна',
    Portrait: 'Книжкова',
    PreviewHint: 'Перетягуйте, щоб переміщати, прокручуйте або зводьте пальці, щоб масштабувати область експорту.',
    ExportFailed: 'Не вдалося експортувати карту. Спробуйте ще раз.',
    PreviewFailed: 'Не вдалося створити попередній перегляд.',
    AdjustArea: 'Налаштувати область на карті',
    AdjustAreaHint: 'Переміщуйте, масштабуйте, обертайте або нахиляйте карту, щоб вибрати область експорту',
    ZoomIn: 'Збільшити',
    ZoomOut: 'Зменшити',
    ResetZoom: 'Скинути масштаб до 100 %',
    Done: 'Готово',
    Cancel: 'Скасувати',
    Scalebar: 'Масштабна лінійка',
    NorthIcon: 'Покажчик півночі',
    ChooseNorthIcon: 'Вибрати покажчик півночі',
    ChooseSvgFile: 'Вибрати файл SVG',
    IconSymbol: 'Символ',
    IconColor: 'Колір',
    IconSize: 'Розмір',
    InvalidSvg: 'Файл не є коректним SVG.',
    ExportAsVector: 'Експортувати як вектор',
    ExportLabelsAsVector: 'Експортувати підписи як вектор',
    Custom: 'Власний',
    Width: 'Ширина',
    Height: 'Висота',
    LanguageName: 'українська',
    LanguageCode: 'uk'
};
export default translation;
